import {
  ChoicesQuery,
  QuestionItem,
  QuestionType,
  questionChoicesKeys,
} from '@seaters/constants';
import {
  fetchGuestQuestionChoices,
  fetchQuestionChoices,
  fetchQuestionChoicesWithoutHeaders,
  getSessionToken,
} from '@seaters/data-access';
import { useQueries } from '@tanstack/react-query';

const CHOICE_BASED_QUESTION_TYPES = new Set<QuestionType>([
  QuestionType.CHECKBOX,
  QuestionType.MULTIPLE_CHOICE,
  QuestionType.MULTIPLE_CHOICE_RANGE,
  QuestionType.MULTIPLE_CHOICE_DROPDOWN,
  QuestionType.MULTIPLE_CHOICE_MULTIPLEANSWER,
  QuestionType.MULTIPLE_CHOICE_WITH_OTHER,
  QuestionType.MULTIPLE_CHOICE_WITH_OTHER_DROPDOWN,
  QuestionType.MULTIPLE_CHOICE_AUTO_COMPLETE,
  QuestionType.MULTIPLE_CHOICE_AUTO_COMPLETE_MULTIPLEANSWER,
  QuestionType.MULTIPLE_CHOICE_WITH_OTHER_AUTO_COMPLETE,
  QuestionType.MULTIPLE_CHOICE_WITH_OTHER_AUTO_COMPLETE_MULTIPLEANSWER,
]);

export const useFetchAllQuestionsChoices = (
  questions: QuestionItem[] | [],
  isGuest: boolean
) => {
  const auth = getSessionToken();

  const params: ChoicesQuery = {
    size: 5000,
  };

  const code = new URLSearchParams(window.location.search).get('code');
  const token = new URLSearchParams(window.location.search).get('token'); // SURVEY AFTER EVENT

  const questionIds = Array.from(
    new Set(
      questions
        .filter((item) => CHOICE_BASED_QUESTION_TYPES.has(item.question.type))
        .map((item) => item.question.id)
    )
  );

  const queries = questionIds.map((questionId) => {
    return {
      queryKey: questionChoicesKeys.listPerQuestion(questionId),
      queryFn:
        (!auth && !isGuest) || token
          ? () =>
              fetchQuestionChoicesWithoutHeaders(questionId, {
                ...params,
                code: token ?? '',
              })
          : isGuest && code
          ? () => fetchGuestQuestionChoices(questionId, { ...params, code })
          : () => fetchQuestionChoices(questionId, params),
      enabled: !!questionId,
      staleTime: 5 * 60 * 1000,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      retry: 3,
    };
  });
  return useQueries({
    queries: queries,
  });
};
